<template>
    <div v-if = "!isLoading">
        <portal target-el="#filter">
            <div class="sub-header">
                <div class="header-item">
                    <Breadcrumb type="flex" separator-class="el-icon-arrow-right">
                        <breadcrumb-item
                        :to="routeToIndent"
                        >{{ $t('INDENT_OUTBOUND') }}</breadcrumb-item>
                        <breadcrumb-item>{{ $t('RFQ_APPROVAL') }}</breadcrumb-item>
                        <breadcrumb-item>{{ indentDetails.order_number }} </breadcrumb-item>
                    </Breadcrumb>
                </div>
                <div class="header-item f-right pr-10" v-if="!isRfqAccepted">
                    <Popover
                    v-model:visible="isPopoverVisible"
                    placement="bottom-end"
                    width="400"
                    :visible-arrow="false"
                    popper-class="popover-dark mt-m25 px-20 pb-20">
                    
                    <div class="popover-wrapper mb-10">
                        <h4 class="text-brand text-md pt-10">{{ $t('MDM_REJECT_REASON')}}</h4>
                        <div class="text-grey-dark text-sm mb-15">{{ $t('SELECT_RFQ_REJECTION_REASON') }}</div>
                        <div class="mb-15">
                            <div class="mb-10 transparent-textarea">
                                <label for="comment" class="text-grey1 p-10 pb-0 text-sm required">{{ $t('Comments') }}</label>
                                <textarea v-model="comment" id="comment" rows="2" placeholder="Enter your comment..."></textarea>
                            </div>
                        </div>
                        <div class="f-right">
                            <Button type="secondary" size="mini" @click="closePopover">{{ $t('CANCEL') }}</Button>
                            <Button type="primary" size="mini" @click = "rejectFreight" :disabled="!selectedVehicleTypeId">{{ $t('REJECT') }}</Button>
                        </div>
                    </div>
                    <span slot="reference">
                        <Button type="secondary" size="small" class="text-red mr-10" v-if="!isRfqAccepted">{{ $t('REJECT') }}</Button>
                    </span>
                    </Popover>
                    <Button type="primary" size="small" @click = "approveFreight" :disabled="!selectedVehicleTypeId" v-if="!isRfqAccepted">{{ $t('APPROVE') }}</Button>
                </div>
            </div>
        </portal>

        <div class="bg-white p-15 mb-10 mt-m10 ">
            <div class="d-flex align-items-center justify-content-between mb-10">
                <div>
                    <h4 class="text-sm text-blue-dark1 m-0">{{ $t("INDENT_QUOTES") }}&nbsp;&nbsp;-
                       <strong class="text-bold text-green" v-if="isRfqAccepted">{{ $t("MDM_APPROVED") }}</strong>
                       <strong class="text-bold text-yellow" v-else>{{ $t("MDM_PENDING") }}</strong>
                    </h4>
                </div>
            </div>


            <div>
               <Quotes
                  :order="indentDetails"
                  :isRfqApprovalPage="true"
                  @updateSelected="updateSelectedPayload"
                  @updateSelectedVehicleTypeId="updateSelectedVehicleTypeId"
                  @refreshPage="fetchData"
                  @updateRfqData = "updateRfqData"
                />
            </div>

            <h4 class="text-sm text-blue-dark1 mt-15">{{ $t("INVOICE_INDENT_DETAILS") }}</h4>
            <div class="flex-container panel-head align-top mt-m10">
            <div class="flex-item">
                <p>
                  {{$t('INDENT_VEHICLE_REQUIREMENT_DATE')}}:
                    <strong class="text-bold">{{ $moment(indentDetails.sources[0].loading_date).format("DD-MM-YYYY | hh:mm A") }}</strong>
                </p>
                <p>
                  {{$t('INDENT_SHIPPED_FROM')}}
                    <strong class="text-bold">{{ indentData.source }}</strong>
                </p>
                <p>
                  {{$t('INDENT_SHIPPED_TO')}}
                    <strong class="text-bold">{{ indentData.destination }}</strong>
                </p>
            </div>
            <div class="flex-item">
                <p>
                  {{$t('INDENT_VEHICLE')}}
                    <strong class="text-bold">{{ indentData.vehicle }}</strong>
                </p>
                <p>
                  {{$t('INDENT_DELIVERY_TYPE')}}:
                    <strong class="text-bold">{{ indentData.deliveryType }}</strong>
                </p>
                <p>
                   {{$t('INDENT_BASE_FREIGHT')}}:
                    <strong class="text-bold text-green">INR {{ indentData.baseFreight}}</strong>
                </p>
            </div>
            </div>
        </div>
    </div>

  </template>

<script>
import { RFQConstants } from 'pando-constants';
import contractConstants from '@/constants/contract';
import Quotes from '@/components/orders/actions/Quotes';


export default {
  components: {
    Quotes,
  },
  data() {
    return {
      isPopoverVisible: false,
      comment: '',
      value: '',
      isLoading: false,
      indentDetails: {},
      remarks: '',
      selectedFreight: {
        amount: null,
        unit: null,
        attachment_ids: [],
        isShipperApproval: false,
        userRejected: false,
        sendForApproval: true,
      },
      indentData: {
        source: '',
        destination: '',
        vehicle: '',
        deliveryType: '',
        baseFreight: '',
      },
      selectedTransporterId: null,
      selectedVehicleTypeId: null,
      isRfqAccepted: false,
      rfqDetailsData: {},
    };
  },
  computed: {
    getFreightAttachments() {
      return this.selectedFreight.attachment_ids;
    },
    routeToIndent() {
      return '/indents/outbound';
    },
  },
  methods: {
    updateSelectedPayload(data) {
      this.selectedTransporterId = data;
    },
    updateRfqData(data) {
      this.rfqDetailsData = data;
    },
    updateSelectedVehicleTypeId(data) {
      this.selectedVehicleTypeId = data;
    },
    togglePopover() {
      this.isPopoverVisible = !this.isPopoverVisible;
    },
    closePopover() {
      this.isPopoverVisible = false;
    },
    getIndentDetailsSourceOrDestination(indentDetails, key) {
      let location = '';
      if (indentDetails &&
            indentDetails[key] &&
            indentDetails[key].length > 0 &&
            indentDetails[key][0] &&
            indentDetails[key][0].details &&
            indentDetails[key][0].details.name
      ) {
        const details = indentDetails[key][0].details;
        location = details.name;
        if (details.city) location += `, ${details.city}`;
        if (details.state) location += `, ${details.state}`;
      }

      return location;
    },
    createData(indentDetails) {
      this.selectedFreight.amount = indentDetails.base_frieght.base_freight;
      this.selectedFreight.attachment_ids = [];
      this.selectedFreight.unit = contractConstants.freightUnit[indentDetails.base_frieght.freight_unit];
      this.indentData.source = this.getIndentDetailsSourceOrDestination(indentDetails, 'sources');
      this.indentData.destination = this.getIndentDetailsSourceOrDestination(indentDetails, 'destinations');
      this.indentData.vehicle = indentDetails.vehicle_type.name || '';
      this.indentData.deliveryType = indentDetails.vehicle_type.type || '';
      this.indentData.baseFreight = indentDetails.base_frieght.base_freight || '';
      this.isRfqAccepted = indentDetails.rfq_accepted && indentDetails.rfq_accepted.length > 0;
    },
    async updateFreight() {
      try {
        let payload = {
          isShipperApproval: this.selectedFreight.isShipperApproval,
          comment: this.comment,
          quotes: [
            {
              transporter_id: this.selectedTransporterId,
              status: RFQConstants.QuoteStatus.SHIPPER_ACCEPT, // shipper approval
              vehicle_type_id: this.selectedVehicleTypeId,
            },
          ],
        };
        if (this.selectedFreight.userRejected) {
          const updatedStatusQuote = payload.quotes.map(quote => ({
            ...quote,
            status: RFQConstants.QuoteStatus.TRANSPORTER_ACCEPT,
          }));
          payload = {
            ...payload,
            quotes: updatedStatusQuote,
            sendForApproval: this.selectedFreight.sendForApproval,
            userRejectedQuote: this.selectedFreight.userRejected,
          };
        }
        const result = await this.$store.dispatch('order/rfqupdate', {
          orderNo: this.indentDetails.order_number,
          payload,
        });
        if (result) {
          if (this.selectedFreight.userRejected) {
            this.$error({ message: result.successMessage || this.$getErr('RFQ_APPROVAL_FAILURE') });
            setTimeout(() => {
              this.$success({ message: this.$t('RFQ_REDIRECT_TO_INDENT_PAGE') });
              this.$router.push({ path: '/indents/outbound' });
            }, 2000);
          } else {
            this.$successMessage({
              message: result.successMessage || this.$getSuccess('RFQ_APPROVAL_SUCCESS'),
            });
            this.$router.push({ path: '/indents/outbound' });
          }
        }
        if (result.error) {
          this.$error({
            message: result.error,
          });
        }
      } catch (error) {
        this.$error({ message: this.$getErr('APP_CATCH_ERR') });
      }
    },
    async approveFreight() {
      this.selectedFreight.isShipperApproval = true;
      this.selectedFreight.sendForApproval = false;
      await this.updateFreight();
    },
    async rejectFreight() {
      this.selectedFreight.userRejected = true;
      this.selectedFreight.sendForApproval = false;
      await this.updateFreight();
      this.closePopover();
    },
    async fetchData() {
      try {
        this.isLoading = true;
        const indentDetails = await this.$store.dispatch('order/find', this.$route.params.orderId);
        if (!indentDetails || indentDetails.status === 404) {
          this.$error({ message: this.$t('SOMETHING_WENT_WRONG') });
          this.$router.push({ path: '/indents/outbound' });
        } else {
          this.indentDetails = indentDetails;
          this.createData(indentDetails);
          this.isLoading = false;
        }
      } catch (error) {
        throw (error);
      }
    },
  },
  async created() {
    await this.fetchData();
  },
};
</script>
<style lang="scss" scoped>
.text-yellow {
  color:rgba(192, 150, 45, 0.9);
  padding: 5px;
}
</style>
